import BaseModel from '../core/BaseModel';
import ShowroomModel from '@/models/ShowroomModel'

export default class RentalOrderBuyModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'rental_order_buy',
        tableName: 'rental_order_buy',
        label: 'Visit List',
        display_key: 'name',
      },
      {
        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },
        rental_order_id: {
          name: 'rental_order_id',
          type: 'Uuid',
          filter: {type: 'input', match: 'contains'},
          label: 'Order ID',
          class:"left",
        },
        plate_number: {
            name: "plate_number",
            label: "Plate Number",
            type: "Computed",
            filter: {type: 'input', match: 'contains'},
            computed: (data) => {
                data.plate_number ='' ;
            },
            class:"left",
            width : 8,
        },
        buy_name: {
          name: 'buy_name',
          type: 'String',
          filter: {type: 'input', match: 'contains'},
          label: 'Contact Name',
          class:"left",
        },
        
        buy_phone: {
          name: 'buy_phone',
          type: 'String',
          label: 'Phone Number',
          filter: {type: 'input', match: 'contains'},
          class:"left",
        },
        buy_preferred_date: {
          name: 'buy_preferred_date',
          type: 'String',
          label: 'Appointment',
          filter: { type: 'DateRange', match: 'contains' },
          class:"left",
        },

        status_item: {
          name: 'status_item',
          type: 'Computed',
          label: 'Item Status',
          computed: (data) => {
            data.status_item ='' ;
        },
        options: [
            {value: 'FOR_SELL', label: 'For Sell'},
            {value: 'SOLD_OUT_SELL', label: 'Sold Out'},
        ],
        filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals'
        },
        class:"left",
        },
        visit_status: {
            name: 'visit_status',
            type: 'Computed',
            label: 'Visit Status',
            computed: (data) => {
              data.visit_status ='' ;
          },
          options: [
              {value: 'BOOKING_BUY', label: 'Booking'},
              {value: 'PENDING_BUY', label: 'Pending'},
              {value: 'SOLD_BUY', label: 'Sold'},
              {value: 'CANCEL_BUY', label: 'Cancel'}
          ],
          filter: {
              type: 'select',
              optionLabel: 'label',
              optionKey: 'value',
              match: 'equals'
          },
          class:"left",
          },
          source : {
            name: 'source',
            type: "Computed",
            label: 'Source',
            filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            options: [
              {value: 'WEB', label: 'Website', style: 'color:  #000000;'},
              {value: 'IOS', label: 'Ios',style: 'color:  #000000;'},
              {value: 'ANDROID', label: 'Android',style: 'color:  #000000;'},
            ],
            computed: (data) => {
                data.source ='' ;
            },
            class:"left",
            width : 8,
        },


          showroom_id: {
            name:'showroom_id',
            label:'Showroom',
            type: "computed",
            models: new ShowroomModel(),
            filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            class:"left",
            computed: (data) => {
                data.showroom_id = '';
            },
            width : 8,
        },
        rating: {
            name: "rating",
            label: "Rate",
            type: "Computed",
            computed: (data) => {
                data.rating ='' ;
            },
            class:"left",
            width : 8,
        },
        updated_by: {
            name: 'updated_by',
            type: 'Uuid',
            label: 'Updated By',
            computed: (data) => {
                data.updated_by ='' ;
            },
          },
        updated_at: {
          name: 'updated_at',
          type: 'Timestamp',
          label: 'Updated date',
        },
        detail_get: {
            refs:  ' car_for_sell { id code model build status price plate_number obj_showroom { id name} obj_colour {id name } obj_vehicle_category { id name }  }  rental_order {is_edit_admin id uid code source booking_status note hide_rate point_reward ref_uid rate { id number_rate obj_id note } user {id fullname phone } } update_user {id fullname } ',
            display: false
        },
        detail_get1: {
          refs:  ' created_at buy_name buy_name buy_preferred_date buy_phone buy_email voucher_id voucher_code voucher_discount redeemed amount_order ',
          display: false
        },
      }
    );
  }
}